<template>
  <v-container fluid class="mt-0 pt-12" style="background-color: #fff">
    <v-container>
      <v-form
        :class="$vuetify.breakpoint.mdAndUp ? 'px-5' : ''"
        ref="signupForm"
        :lazy-validation="true"
      >
        <p class="text-center text-pink font-weight-medium body-1">
          Welcome to theLIFEBOARD 👋
        </p>
        <h1 class="display-2 mb-12 text-purple text-center font-weight-medium">
          Sign up
        </h1>

        <v-row class="my-8" justify="center" align="top">
          <v-col cols="12" md="7" lg="7" xl="5" class="text-center">
            <p class="text-center title">
              <v-icon left>fas fa-wallet</v-icon> Choose your plan
            </p>

            <v-row justify="center">
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="4"
                class="text-center"
                v-for="plan in subscriptionPlans"
                :key="plan.id"
              >
                <v-card
                  outlined
                  @click="selectPlan(plan.id)"
                  class="px-4 py-4 rounded-lg"
                  :class="
                    subscriptionType == plan.id
                      ? ' border-purple  border-2 text--white bg-primary'
                      : 'no-shadow grey--text text--darken-1 '
                  "
                  :elevation="subscriptionType == plan.id ? 20 : 0"
                >
                  <v-card-text class="text-center">
                    <div
                      class=""
                      :class="
                        $vuetify.breakpoint.lgAndUp ? 'title-xl' : 'title-l'
                      "
                    >
                      <div
                        class=""
                        :class="
                          subscriptionType == plan.id
                            ? 'white--text'
                            : 'grey--text text--darken-1'
                        "
                        v-if="$vuetify.breakpoint.lgAndUp"
                      >
                        <p class="font-weight-medium">${{ plan.price }}</p>
                        <p :class="plan.primary ? 'font-weight-bold' : ''">
                          {{ plan.name }}
                        </p>
                      </div>
                      <div v-else>
                        <p
                          :class="
                            subscriptionType == plan.id
                              ? 'font-weight-bold white--text'
                              : ''
                          "
                        >
                          <span>{{ plan.name }}</span>
                          <span class=" font-weight-medium"
                            >&nbsp;${{ plan.price }}</span
                          >
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="$vuetify.breakpoint.mdAndDown"
                      class="text-center subtitle-1"
                      :class="
                        subscriptionType == plan.id
                          ? 'font-weight-bold white--text'
                          : 'text-pink'
                      "
                      v-html="plan.msg"
                    ></div>
                    <div
                      v-if="$vuetify.breakpoint.lgAndUp"
                      class="text-center  subtitle-1"
                      :class="
                        subscriptionType == plan.id
                          ? 'font-weight-bold white--text'
                          : 'text-pink'
                      "
                      v-html="plan.message"
                    ></div>
                  </v-card-text>
                  <v-card-actions v-if="subscriptionType == plan.id">
                    <v-spacer></v-spacer>
                    <v-icon color="white">fas fa-check-circle</v-icon>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <p class="text-center mt-4 font-weight-medium">
              {{ paymentExplanation }}
            </p>

            <p class="caption mt-4">
              Lock this price as we add more features.
            </p>
          </v-col>
          <v-col sm="7" md="5" lg="4" xl="3">
            <p class="text-center title">
              <v-icon left>fas fa-user-edit</v-icon> Enter your details
            </p>
            <v-card class="" elevation="0">
              <v-card-text>
                <v-text-field
                  prepend-icon="fas fa-user"
                  outlined
                  dense
                  v-model="signup.user"
                  :autofocus="!prePopulated"
                  name="name"
                  label="Name"
                  :rules="nameRules"
                  required
                ></v-text-field>
                <v-text-field
                  prepend-icon="fas fa-envelope"
                  outlined
                  dense
                  v-model="signup.email"
                  type="text"
                  name="email"
                  label="Email"
                  :rules="emailRules"
                  :readonly="prePopulated"
                ></v-text-field>
                <v-text-field
                  :prepend-icon="pass_ok_icon"
                  outlined
                  dense
                  v-model="signup.pass"
                  :autofocus="prePopulated"
                  type="password"
                  name="password"
                  label="Password"
                  :rules="passRules"
                ></v-text-field>

                <v-text-field
                  :prepend-icon="pass_ok_icon"
                  outlined
                  dense
                  v-model="signup.pass_rep"
                  type="password"
                  name="password_repeat"
                  label="Confirm your password"
                  :rules="passrepRules"
                  v-on:keyup.enter="handlePayment"
                ></v-text-field>

                <p class="text-center">
                  By creating your account you're accepting our
                  <a href="https://thelifeboard.app/terms" target="_blank"
                    >Terms of Service</a
                  >
                  and
                  <a href="https://thelifeboard.app/privacy" target="_blank">
                    Privacy Policy</a
                  >
                </p>
                <v-alert
                  v-if="message.show"
                  :type="message.type"
                  outlined
                  dense
                  class="text-center body-2"
                  >{{ message.text }}</v-alert
                >
                <div class="text-center">
                  <v-btn
                    primary
                    dark
                    color="secondary"
                    class="my-3"
                    :loading="isLoading"
                    @click="handlePayment"
                    >Create my account</v-btn
                  >
                  <p
                    class="text-center text-pink font-weight-medium body-1 pt-8"
                  >
                    Already have an account?
                    <router-link
                      class="text-purple link-underlined"
                      :to="{name: 'login'}"
                      >Log in here</router-link
                    >
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <ReasonsSubscription />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <FAQSubscriptions />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ReasonsSubscription from '@/components/common/ReasonsSubscription'
import FAQSubscriptions from '@/components/common/FAQSubscriptions'
import NetlifyService from '@/services/NetlifyService'
export default {
  components: {
    ReasonsSubscription,
    FAQSubscriptions,
  },
  data() {
    return {
      signup: {
        user: '',
        pass: '',
        pass_rep: '',
        email: '',
      },
      acceptTerms: false,
      subscriptionType: process.env.VUE_APP_QUARTERLY_PLAN_ID,
      subscriptionPlans: [
        {
          name: 'Monthly',
          desc: 'paid every month',
          id: process.env.VUE_APP_MONTHLY_PLAN_ID,
          price: 4.99,
          message: `If you just want to give it a try 😉`,
          msg: `Just trying it`,
          elevation: 2,
        },
        {
          name: 'Quarterly',
          desc: 'paid every three months',

          id: process.env.VUE_APP_QUARTERLY_PLAN_ID,
          price: 13.99,
          primary: true,
          message: `You're committed to star the change! <br> 15% discount 🤙`,
          msg: `15% discount`,
          elevation: 20,
        },
        {
          name: 'Yearly',
          desc: 'paid once a year',

          id: process.env.VUE_APP_YEARLY_PLAN_ID,
          price: 49.99,
          primary: true,
          message: `Let's do it!<br> This year you're unstoppable! Get two months free 🤑`,
          msg: `Two months free`,
          elevation: 7,
        },
      ],

      isLoading: false,
      prePopulated: false,
      subscriptionRules: [v => !!v || 'Plan is required'],
      nameRules: [
        v => !!v || 'Name is required',
        v =>
          /^[\S]+$/.test(v) ||
          'Name should not contain spaces (just your first name 😉)',
      ],

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be a valid address',
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters',
      ],
      passrepRules: [
        v => !!v || 'Confirm password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters',
        v =>
          (v && v === this.signup.pass) ||
          'Password and confirmation should be the same',
      ],
      message: {
        show: false,
        text: 'Error. Check your details and try again',
        type: 'error',
      },
    }
  },
  mounted() {
    if (this.$route.query.name && this.$route.query.email) {
      this.signup.user = this.$route.query.name
      this.signup.email = this.$route.query.email
      this.prePopulated = true
    }
    if (this.$route.query.plan == 'monthly') {
      this.subscriptionType = process.env.VUE_APP_MONTHLY_PLAN_ID
    }
    if (this.$route.query.plan == 'quarterly') {
      this.subscriptionType = process.env.VUE_APP_QUARTERLY_PLAN_ID
    }
    if (this.$route.query.plan == 'yearly') {
      this.subscriptionType = process.env.VUE_APP_YEARLY_PLAN_ID
    }
  },
  created() {
    this.loadFontAwesomeCSS()
    // load Paddle library
    this.$loadScript('https://cdn.paddle.com/paddle/paddle.js')
      .then(() => {
        // Script is loaded, do something
        if (process.env.PADDLE_TEST) {
          Paddle.Environment.set('sandbox')
          console.log('Paddle test env')
        }
        Paddle.Setup({
          vendor: process.env.VUE_APP_VENDOR_ID * 1,
        })
      })
      .catch(() => {
        // Failed to fetch script
        console.error('Error loading script')
      })
  },
  methods: {
    loadFontAwesomeCSS() {
      let file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = 'https://use.fontawesome.com/releases/v5.8.2/css/all.css'
      document.head.appendChild(file)
    },
    selectPlan(id) {
      this.subscriptionType = id
    },
    async handleSignUp() {
      try {
        // dispatch action which return a Promise
        const user = await this.$store.dispatch('register', {
          body: {
            username: this.signup.email,
            name: this.signup.user,
            email: this.signup.email,
            password: this.signup.pass,
          },
        })
        this.$store.dispatch('createUserEvent', {
          eventName: 'signup',
        })
        // add to Mailchimp
        try {
          await NetlifyService.subscribeUser({
            name: this.signup.user,
            email: this.signup.email,
            tags: ['webapp', `page-${this.$route.name}`, 'on-subscription'],
          })
        } catch (error) {
          console.error(error)
          console.log('Error subscribing user')
        }
        // if register ok, redirect
        this.$router.push(`/@${user.name}/onboard`)
      } catch (e) {
        this.isLoading = false

        // show error in component
        if (e.data[0].messages[0].message)
          this.message.text = e.data[0].messages[0].message
        this.message.show = true
        this.isLoading = false
      }
    },
    async handlePayment() {
      // saves reference to method to be used as successCallback
      var signUp = this.handleSignUp

      if (this.$refs.signupForm.validate()) {
        this.isLoading = true
        const _this = this

        // opens Paddle checkout overlay
        Paddle.Checkout.open({
          product: this.subscriptionType,
          email: this.signup.email,
          allowQuantity: false,
          successCallback: signUp,
          closeCallback: function(data) {
            console.log(data)
            _this.isLoading = false
          },
        })
      }
    },
  },

  computed: {
    paymentExplanation() {
      if (this.subscriptionType == process.env.VUE_APP_MONTHLY_PLAN_ID) {
        return `Pay $${this.subscriptionPlans[0].price} now and then every month.`
      } else if (
        this.subscriptionType == process.env.VUE_APP_QUARTERLY_PLAN_ID
      ) {
        return `Pay $${this.subscriptionPlans[1].price} now and then every three months.`
      } else {
        return `Pay $${this.subscriptionPlans[2].price} now and don't pay again after twelve months.`
      }
    },
    pass_ok_icon() {
      if (
        this.signup.pass.length >= 6 &&
        this.signup.pass_rep.length >= 6 &&
        this.signup.pass === this.signup.pass_rep
      ) {
        return 'fas fa-lock'
      }
      return 'fas fa-lock-open'
    },
  },
  metaInfo: {
    title: 'Sign Up',
    titleTemplate: '%s | theLIFEBOARD.app',
    link: [
      {
        rel: 'canonical',
        href: 'https://app.thelifeboard.app/signup',
      },
    ],
    // Define meta tags here.
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {
        name: 'description',
        content: 'The app that helps you achieve your goals and create habits',
      },
      // OpenGraph data (Most widely used)
      {
        property: 'og:title',
        content:
          'theLIFEBOARD - The app that helps you achieve your goals and create habits',
      },
      {property: 'og:site_name', content: 'theLIFEBOARD.app'},
      // The list of types is available here: http://ogp.me/#types
      {property: 'og:type', content: 'website'},
      // Should the the same as your canonical link, see below.
      {property: 'og:url', content: 'https://thelifeboard.app'},
      {
        property: 'og:image',
        content: 'https://thelifeboard.app/img/mails/mind_map.png',
      },
      // Often the same as your meta description, but not always.
      {
        property: 'og:description',
        content: 'The app that helps you achieve your goals and create habits',
      },

      // Twitter card
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:site', content: 'https://thelifeboard.app'},
      {name: 'twitter:title', content: 'theLIFEBOARD | Sign Up'},
      {
        name: 'twitter:description',
        content: 'The app that helps you achieve your goals and create habits',
      },
      // Your twitter handle, if you have one.
      {name: 'twitter:creator', content: '@the_life_board'},
      {
        name: 'twitter:image:src',
        content: 'https://thelifeboard.app/img/mails/mind_map.png',
      },

      // Google / Schema.org markup:
      {itemprop: 'name', content: 'theLIFEBOARD | Sign Up'},
      {
        itemprop: 'description',
        content: 'The app that helps you achieve your goals and create habits',
      },
      {
        itemprop: 'image',
        content: 'https://thelifeboard.app/img/mails/mind_map.png',
      },
    ],
  },
}
</script>

<style></style>
